// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './bot-commands-api';

export const useListBotCommands: typeof hookExports.useListBotCommands =
  hookExports.useListBotCommands;
export const useLazyListBotCommands: typeof hookExports.useLazyListBotCommands =
  hookExports.useLazyListBotCommands;
export const useGetBotCommand: typeof hookExports.useGetBotCommand = hookExports.useGetBotCommand;
export const useLazyGetBotCommand: typeof hookExports.useLazyGetBotCommand =
  hookExports.useLazyGetBotCommand;
export const useCreateBotCommand: typeof hookExports.useCreateBotCommand =
  hookExports.useCreateBotCommand;
export const useUpdateBotCommand: typeof hookExports.useUpdateBotCommand =
  hookExports.useUpdateBotCommand;
export const useDeleteBotCommand: typeof hookExports.useDeleteBotCommand =
  hookExports.useDeleteBotCommand;
export const useRestoreBotCommand: typeof hookExports.useRestoreBotCommand =
  hookExports.useRestoreBotCommand;
